<template>
	<div class="container">
		<div class="avatar">
			<el-upload :show-file-list="false" :on-success="handleAvatarSuccess" :action="uploadUrl">
				<div class="avatar-cnt">
					<img :src="headPic!=''?headPic:require('@/assets/default-avatar.png')" />
					<span>点击修改头像</span>
				</div>
			</el-upload>
		</div>
		<div class="formlist">
			<span class="form-item">昵称</span>
			<input v-model="nickName" class="inputtext" placeholder="未设置" />
		</div>
		<div class="formlist">
			<span class="form-item">性别</span>
			<div class="radio-sex">
				<el-radio v-model="sex" label="男">男</el-radio>
				<el-radio v-model="sex" label="女">女</el-radio>
			</div>
		</div>
		<div class="formlist">
			<span class="form-item">姓名</span>
			<input v-model="realName" class="inputtext" placeholder="未设置" />
		</div>
		<div class="formlist">
			<span class="form-item">生日</span>
			<el-date-picker v-model="birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
			</el-date-picker>
		</div>
		<div class="formlist">
			<span class="form-item">身份证</span>
			<input v-model="idCard" class="inputtext" placeholder="未设置" />
		</div>
		<div class="btns">
			<a @click="toModify" href="javascript:;" class="active">保存</a>
		</div>
	</div>
</template>

<script>
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	import qs from 'qs'
	export default {
		name: 'UserInfo',
		components: {

		},
		data() {
			return {
				headPic: '',
				nickName: '',
				sex: '',
				realName: '',
				birthday: '',
				idCard: '',
				uploadUrl: '',
				userId: ''
			}
		},
		created() {
			this.userId = localStorage.getItem('uuid') || ''
			this.uploadUrl = config.baseUrl + 'v1/upload/res'
			this.getUserInfo()
		},
		methods: {
			async getUserInfo() {
				let url = 'v1/user/getUserDetail'
				let param = {
					userId: this.userId,
					token: localStorage.getItem('token'),
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res)
					let userInfo = res.data.entity
					this.headPic = userInfo.headPic
					this.nickName = userInfo.nickName
					this.sex = userInfo.sex
					this.realName = userInfo.realName
					this.birthday = userInfo.birthdayStr
					this.idCard = userInfo.idCard
				}
			},
			async toModify() {
				let nickName = this.nickName
				let realName = this.realName
				let idCard = this.idCard
				if (this.headPic.length <= 0) {
					this.$message.error('请上传头像！')
					return
				}
				if (nickName.length <= 0) {
					this.$message.error('昵称不能为空！')
					return
				}
				if (realName.length <= 0) {
					this.$message.error('姓名不能为空！')
					return
				}
				if (idCard) {
					const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
					if (!regIdCard.test(idCard)) {
						this.$message.error('身份证号码有误！')
						return false
					}
				}
				let param = {
					token: localStorage.getItem('token'),
					userId: localStorage.getItem('userId'),
					headPic: this.headPic,
					nickName: this.nickName,
					sex: this.sex,
					realName: this.realName,
					birthday: this.birthday,
					idCard: this.idCard
				}
				ajaxParam(param)
				const res = await post('v1/user/updateUser', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('修改个人信息成功！')
					this.bus.$emit('resfreshheaPic')
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleAvatarSuccess(res) {
				this.headPic = res.entity.fileUrl
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		.avatar {
			display: flex;
			justify-content: center;
			width: 50%
		}

		.avatar-cnt {
			padding-bottom: 10px;

			img {
				width: 72px;
				height: 72px;
				margin-top: 10px;
				border-radius: 50%;
			}

			span {
				display: block;
				margin-top: 0px
			}
		}

		.formlist {
			height: 36px;
			margin-top: 10px;
			line-height: 36px;
			clear: both;
			position: relative;

			.form-item {
				float: left;
				width: 90px;
				margin-right: 20px;
				text-align: right;

				i {
					padding-right: 5px;
					color: red;
				}
			}

			.inputtext {
				width: 290px;
				height: 36px;
				padding: 0 20px;
				background: #f7f7f7;
				border-radius: 6px;
				color: #606060
			}

			.radio-sex {
				float: left;
			}

			.el-radio {
				font-size: 26px !important;
				margin-top: -5px
			}

			.el-radio__label,
			.el-checkbox__label {
				font-size: 14px !important;
			}

			/deep/ .el-input__inner {
				height: 36px
			}

		}

		.btns {
			display: flex;
			margin-top: 20px;
			margin-left: 96px;

			a {
				display: block;
				width: 88px;
				height: 34px;
				margin-left: 15px;
				background: rgba(50, 50, 50, .1);
				border-radius: 16px;
				line-height: 34px;
				text-align: center;
			}

			a:hover,
			a.active {
				background: #CF171D;
				color: #fff;
			}
		}
	}
</style>